import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Icons/White/cavet-down.svg'
import _imports_1 from '@/assets/img/Icons/chevron-up-solid.svg'
import _imports_2 from '@/assets/img/Icons/chevron-down-solid.svg'


const _withScopeId = n => (_pushScopeId("data-v-111a17e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: "loading",
  class: "loading"
}
const _hoisted_2 = {
  key: "content",
  class: "hierarchy-goal-timeline-container"
}
const _hoisted_3 = { class: "content carousel-container" }
const _hoisted_4 = {
  key: 0,
  class: "row header"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "caret",
  src: _imports_0
}, null, -1))
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "trend" }
const _hoisted_8 = {
  key: 0,
  src: _imports_1,
  class: "up"
}
const _hoisted_9 = {
  key: 1,
  src: _imports_2,
  class: "error-red"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingCard = _resolveComponent("LoadingCard")!
  const _component_Typography = _resolveComponent("Typography")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_Carousel = _resolveComponent("Carousel")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "fade",
    mode: "out-in"
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_LoadingCard, { variant: "table" })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_Carousel, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page) => {
                    return (_openBlock(), _createElementBlock("div", { key: page }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hierarchyItems(
                                _ctx.month,
                                _ctx.userName
                            ), (hierarchyItem, row) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: row,
                          class: "carousel-content"
                        }, [
                          (row === (page - 1) * _ctx.numberPerPage)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createVNode(_component_Typography, {
                                  variant: "overline",
                                  class: "name dim hierarchy-title"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.title), 1)
                                  ], undefined, true),
                                  _: 1
                                }),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getLatestHierarchyScore(hierarchyItem), (score, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: index,
                                    class: "month"
                                  }, [
                                    _createVNode(_component_Typography, {
                                      variant: "overline",
                                      class: "hierarchy-title"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.labelScoreType) + " ", 1),
                                        _hoisted_5
                                      ], undefined, true),
                                      _: 1
                                    })
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          (
                                    _ctx.showItem(page, row, hierarchyItem) &&
                                    hierarchyItem.name
                                )
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(["row", [_ctx.getColourClass(hierarchyItem)]])
                              }, [
                                _createElementVNode("div", {
                                  class: "name",
                                  onClick: ($event: any) => (_ctx.drillDown(hierarchyItem))
                                }, [
                                  (hierarchyItem.allowDrilldown)
                                    ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                                        key: 0,
                                        icon: _ctx.faArrowCircleRight,
                                        class: _normalizeClass([
                                            _ctx.getColourClass(hierarchyItem),
                                            'arrow-icon',
                                        ]),
                                        size: "sm"
                                      }, null, 8, ["icon", "class"]))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(hierarchyItem.name), 1)
                                ], 8, _hoisted_6),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getLatestHierarchyScore(hierarchyItem), (score, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: index,
                                    class: "month",
                                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleIconScore && _ctx.toggleIconScore(...args)))
                                  }, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["score", [_ctx.getScoreClass(score)]])
                                    }, _toDisplayString(_ctx.formatScore(
                                                score.metricScore,
                                                _ctx.isFiveScoreQuestionType(
                                                    _ctx.scoreType
                                                ),
                                                _ctx.$companyVars.has_display_csat_as_percentage,
                                                _ctx.scoreType,
                                                _ctx.$companyVars?.decimals
                                            )), 3),
                                    _createElementVNode("span", _hoisted_7, [
                                      (score.change >= 0)
                                        ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                                        : (_openBlock(), _createElementBlock("img", _hoisted_9))
                                    ])
                                  ]))
                                }), 128))
                              ], 2))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  }), 128))
                ], undefined, true),
                _: 1
              })
            ])
          ]))
    ], undefined, true),
    _: 1
  }))
}